var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._b({tag:"component",attrs:{"tag":"li"},nativeOn:{"click":function($event){return _vm.hideSidebar.apply(null, arguments)}}},'component',_vm.$attrs,false),[_c('a',_vm._b({staticClass:"nav-link"},'a',_vm.$attrs,false),[_vm._t("default",function(){return [_c('p',[_vm._v(_vm._s(_vm.link.name))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }